<div class="modal-content">
  <div class="modal-header align-items-center">
    <div class="d-flex flex-column">
      <h2 class="modal-title mb-1">{{ editMode ? ('companyProfile.addSponsor.editTitle' | translate) : ('companyProfile.addSponsor.title' | translate) }}</h2>
      <p class="text-muted small mb-0">{{ 'common.requiredFields' | translate }}</p>
    </div>
    <i class="fa-solid fa-xmark fs-2 cursor-pointer" (click)="close()"></i>
  </div>

  <div class="modal-body">
    <div class="row">
      <h3>{{ 'companyProfile.addSponsor.sponsorInfo' | translate }}</h3>
    </div>

    <div class="row spacing-15">
      <div class="col-12">
        <app-input-component
          [label]="('companyProfile.addSponsor.name' | translate) + ' *'"
          [type]="'text'"
          [placeholder]="'companyProfile.addSponsor.namePlaceholder' | translate"
          [(value)]="sponsor_name"
          [invalid]="isSponsorNameInvalid"
        />
      </div>
    </div>

    <div class="row spacing-15">
      <div class="col-12">
        <app-input-component
          [label]="'companyProfile.addSponsor.description' | translate"
          [type]="'text'"
          [placeholder]="'companyProfile.addSponsor.descriptionPlaceholder' | translate"
          [(value)]="sponsor_description"
        />
      </div>
    </div>

    <div class="row spacing-30">
      <div class="col-12">
        <h4>{{ 'companyProfile.addSponsor.logo' | translate }}</h4>
        <p class="text-muted small mb-2">{{ 'companyProfile.addSponsor.logoHint' | translate }}</p>
        <app-fileorini
          [accept]="'image/*'"
          (filesChanged)="logoFile = $event[0]"
        />
      </div>
    </div>
  </div>

  <div class="modal-footer">
    <div class="row">
      <div class="col-12 d-flex justify-content-end gap-2">
        <app-button
          [variant]="'ghost'"
          [label]="'common.cancel' | translate"
          (clicked)="close()"
        />
        <app-button
          [variant]="'primary'"
          [label]="saving ? ('common.saving' | translate) : (editMode ? ('common.saveChanges' | translate) : ('companyProfile.addSponsor.add' | translate))"
          [iconClass]="saving ? 'fa fa-spinner fa-spin' : (editMode ? 'fa fa-save' : 'fa fa-plus')"
          [disabled]="saving"
          (clicked)="onSave()"
        />
      </div>
    </div>
  </div>
</div>
